import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination, Navigation, Autoplay, EffectFade } from 'swiper/modules'
import useScriptData from '../core/hooks/useScriptData'
import {useCallback} from '@wordpress/element'
import {BaseProps} from '../types'

export default function SlideBanner(props: BaseProps) {
  const { data = [] } = props.data

  const renderSlides = useCallback(() => {
    if (!Array.isArray(data)) return null
    return data.map((item, index) => {
      return (
        <SwiperSlide key={index}>
          <div className="h-[219px] lg:h-[773px] w-full relative">
            <div className="absolute top-0 left-0 w-full h-full">
              <img className="w-full h-full object-cover" alt="" src={item.image_url}/>
            </div>
            <div className="container mx-auto h-full relative z-20">
              <div className="absolute right-[30px] bottom-2 lg:right-[80px] lg:top-[187px] z-20">
                <div
                  className="w-[200px] lg:w-[637px] py-[17px] lg:py-[46px] mb-[10px] rounded-[10px] overflow-hidden relative bg-black bg-opacity-30 [backdrop-filter:blur(12px)]">
                  <div className="mb-[10px]">
                    <div className="text-[18px] leading-[22px] lg:text-[64px] lg:leading-[normal]">
                      {item.title}
                    </div>
                    <div
                      className="text-[16px] leading-[22px] font-semibold text-orange lg:text-[64px] lg:leading-[74px]">
                      {item.sub_title}
                    </div>
                  </div>
                  <a href={item.link} target={item.link_target || ''} className="btn inline-block text-[12px] lg:text-[18px] px-4 py-[2px] lg:py-2">
                    {item.link_text || 'Tìm hiểu thêm'}
                  </a>
                </div>
                {/*<div className="lg:hidden text-center">*/}
                {/*  <img className="w-[88px] lg:w-[194px] h-5 lg:h-[47px] relative z-[1] inline-block" loading="lazy"*/}
                {/*       alt=""*/}
                {/*       src="<?php echo get_stylesheet_directory_uri().'/assests/images/public/frame-141.svg' ?>"/>*/}
                {/*</div>*/}
              </div>
            </div>
          </div>
        </SwiperSlide>
      )
    })
  }, [data])

  return (
    <div className="flex flex-col items-start justify-start max-w-full shrink-0 text-center text-white font-exo relative banner-crop">
      <Swiper
        slidesPerView={1}
        className={'w-full relative'}
        simulateTouch={false}
        loop={true}
        modules={[Pagination, Navigation, Autoplay, EffectFade]}
        effect={'fade'}
        navigation={{
          prevEl: '.pre-slide-btn',
          nextEl: '.next-slide-btn',
        }}
        pagination={{
          el: '.slide-pagination',
          // dynamicBullets: true,
          clickable: true,
          bulletClass: 'swiper-pagination-bullet !opacity-100 !mx-1 lg:!mx-4 bg-gray-100 w-1 h-1 lg:w-2 lg:h-2',
          bulletActiveClass: '!bg-blue-100 !bg-opacity-1'
        }}
        autoplay={{
          delay: 5000,
          disableOnInteraction: true
        }}
      >
        { renderSlides() }
      </Swiper>

      <div className={'absolute w-full top-1/2 -translate-y-1/2 z-10 px-4'}>
        <div className={'flex justify-between items-center relative'}>
          <div className={'pre-slide-btn w-[12px] h-[24px] lg:w-[28px] lg:h-[50px]'}>
            <svg viewBox="0 0 28 51" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M26.5 2L3 25.5L26.5 49" stroke="white" strokeWidth="3"/>
            </svg>
          </div>
          <div className={'next-slide-btn w-[12px] h-[24px] lg:w-[28px] lg:h-[50px]'}>
            <svg viewBox="0 0 28 51" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2 2L25.5 25.5L2 49" stroke="white" strokeWidth="3"/>
            </svg>
          </div>
        </div>
      </div>

      <div className="absolute bottom-[15px] lg:bottom-[55px] left-1/2 lg:left-1/2 translate-x-[calc(-50%+80px)] lg:-translate-x-1/2 z-10">
        <div className={'flex justify-between items-center relative'}>
          <div className={'custom-slide-pagination'}>
            <div className={'slide-pagination'}></div>
          </div>
        </div>
      </div>
    </div>
  )
}